import "Components/form/claim";

window.changeDocumentNumber = function (input, url) {
    const $form = $(input).parents("form");
    const $orderProductId = $form.find('[name="order_product_id"]');
    const $productNameEl = $form.find('[name="product_name"]');

    if (!$(input).val()) {
        $orderProductId.parents(".form-group").hide();
        $productNameEl.parents(".form-group").show();

        $orderProductId.parents(".c-form__item").parent().hide();
        $productNameEl.parents(".c-form__item").parent().show();
    } else {
        $orderProductId.addClass("is-loading");
        $productNameEl.addClass("is-loading");

        Form.fetchDependentOptions(input, "order_product_id", url, {
            callback: function () {
                $orderProductId.parents(".form-group").show();
                $productNameEl.parents(".form-group").hide();

                $orderProductId.parents(".c-form__item").parent().show();
                $productNameEl.parents(".c-form__item").parent().hide();

                $orderProductId.removeClass("is-loading");
                $productNameEl.removeClass("is-loading");
            },
        });
    }
};

$(function () {
    $('[name="order_product_id"]').bind("change", function () {
        var $this = $(this),
            quantity = $this.find("option:selected").attr("data-quantity"),
            $quantityInput = $("#product-quantity");

        $('[name="product_name"]').val($this.find("option:selected").text());

        $quantityInput.attr("max", quantity);
    });
});
